import React, { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

import { Text, TextType } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';

import { PlaceholderWrapper, PlaceholderBody, PlaceholderFooter } from '.';
import PlaceholderImage from './shipping-box.svg';
import { BASE_SHIPMENTS_PATH } from '../../../../../routes/constants';
import { RECENT_VIEW_ID } from '../../../../../components/shipping-grid/views/view-id-constants';
import { SsrSignOnButton } from '../../../../settings/stores/selected-store/returns-tab/ssr-sign-on-button';
import { useEnhancedReturnRouteMatch } from '../../../../../store/returns/returns.helpers';

import messages from './messages';

export const NoPendingApprovalReturnsPlaceholder = () => {
  const intl = useIntl();
  const history = useHistory();
  const { storeGuid } = useEnhancedReturnRouteMatch();
  const onCallToActionClick = useCallback(() => {
    history.push(`${BASE_SHIPMENTS_PATH}/${RECENT_VIEW_ID}`);
  }, [history]);

  return (
    <PlaceholderWrapper>
      <img alt={intl.formatMessage(messages.noReturnsAltText)} src={PlaceholderImage} />
      <PlaceholderBody>
        <Text textType={TextType.H2} value={messages.noPendingApprovalReturnsHeader} />
        <Text textType={TextType.Paragraph} value={messages.noPendingApprovalReturnsDescription} />
      </PlaceholderBody>
      <PlaceholderFooter>
        <Button onClick={onCallToActionClick} theme='primary'>
          <FormattedMessage {...messages.noReturnsActionButton} />
        </Button>
        <SsrSignOnButton
          label={<FormattedMessage {...messages.configureReturnSettings} />}
          shouldShowIcon={false}
          storeGuid={storeGuid}
          theme='secondary'
        />
      </PlaceholderFooter>
    </PlaceholderWrapper>
  );
};
